import * as THREE from 'three'
import Experience from '../Experience';
import gsap from 'gsap'
import EventEmitter from './EventEmitter.js'

export default class Progressor extends EventEmitter
{
    constructor()
    {
        super()
        this.experience = new Experience();
        this.resources = this.experience.resources;
        this.scene = this.experience.scene;
        this.ui = this.experience.ui;
        this.world = this.experience.world;        
        this.buildFader();
    }

    buildFader()
    {
        this.fader = document.querySelector('.fader')        
        //this.splash = document.querySelector('.splash')    
        this.loadingBarElement = document.querySelector('.loading-bar')          
    }

    onLoaded()
    {
        /*var alpha = {t:1};
        gsap.to(alpha, { 
            duration: 2, 
            t: 0, 
            onStart: ()=>{                
            },
            onComplete: ()=>{
                
                this.splash.classList.add('invisible')  
                this.LoadAnimation();
            }
        }).play();*/
        this.LoadAnimation();
    }

    LoadAnimation()
    {
        var alpha = {t:1};
        var inverse = 0.3;
        this.loadingBarElement.style.transform = `scaleX(${inverse})`
        gsap.to(alpha, { 
            duration: 1.5, 
            t: 0, 
            delay:0.3,
            onStart: ()=>{      
                          
            },
            onUpdate: ()=>{
                this.fader.style.opacity = '${alpha.t}'
                inverse -= alpha;
                this.loadingBarElement.style.transform = `scaleX(${alpha})`
            },
            onComplete: ()=>{
                
                this.fader.classList.add('invisible')  
                this.loadingBarElement.classList.add('ended')
                this.loadingBarElement.style.transform = ''
                this.trigger('onProgressorEnded');
            }
        }).play();
    }   

    onToSegment()
    {
        
        var alpha = {t:1};
        this.fader.classList.remove('invisible')  
       
        gsap.to(alpha, { 
            duration: 1, 
            t: 0,
            delay: 1, 
            onStart: ()=>{
                this.world.unloadIslands();
            },
            onUpdate: ()=>{
                this.fader.style.opacity = '${alpha.t}'
            },
            onComplete: ()=>{          
                this.ui.swapToSegmentEnd();   
                this.fader.classList.add('invisible')        
            }
        }).play();
    }
    onToIsland()
    {        
        var alpha = {t:1};     
        this.fader.classList.remove('invisible') 
        gsap.to(alpha, { 
            duration: 1, 
            t: 0,
            delay: 1, 
            onStart: ()=>{
                this.world.unloadSegment();
            },
            onUpdate: ()=>{
                this.fader.style.opacity = '${alpha.t}'
            },
            onComplete: ()=>{                
                this.ui.swapToIslandEnd();        
                this.fader.classList.add('invisible') 
            }
        }).play();
    }
}